import { forwardRef, Ref, type SVGProps } from 'react';

const SvgGotoIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 27 27"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M25.875 9.375v-8.25m0 0h-8.25m8.25 0L13.5 13.5M10.75 1.125H7.725c-2.31 0-3.465 0-4.348.45a4.13 4.13 0 0 0-1.802 1.802c-.45.883-.45 2.038-.45 4.348v11.55c0 2.31 0 3.465.45 4.348a4.13 4.13 0 0 0 1.802 1.802c.883.45 2.038.45 4.348.45h11.55c2.31 0 3.465 0 4.348-.45a4.13 4.13 0 0 0 1.802-1.802c.45-.883.45-2.038.45-4.348V16.25"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGotoIcon);
export default ForwardRef;
